module.exports = __webpack_public_path__ + "static/media/Gastrodon_gaussian2.e17ddabf.png";